<template>
  <i
    v-if="isRelevant"
    class="tm-visual-expired"
    :class="{ '-self': selfExpired }"
  >
    <i
      v-if="showExpiredOverlays"
      class="-counter"
      v-text="expiredOverlaysText"
    />

    <i v-if="showSelfExpiredBanner" class="-banner"> Expired </i>
  </i>
</template>

<script>
export default {
  name: 'tm-visual-expired',

  props: {
    track: { type: Object, required: true },
    isSceneEdit: { type: Boolean, required: true },
    rectangle: { type: Object, required: true },
    isFirst: { type: Boolean, required: true },
    isBanner: { type: Boolean, required: true },
  },

  computed: {
    isRelevant() {
      return this.selfExpired || this.hasExpiredOverlays;
    },

    selfExpired() {
      return this.$props.track.isExpired;
    },

    hasExpiredOverlays() {
      return this.numberOfExpiredOverlays > 0;
    },

    showExpiredOverlays() {
      return (
        !this.$props.isSceneEdit && this.isFirst && this.hasExpiredOverlays
      );
    },

    showSelfExpiredBanner() {
      return this.selfExpired && this.isBanner && !this.isShort;
    },

    numberOfExpiredOverlays() {
      return this.$props.track.pipa.getNumberOfExpiredOverlays();
    },

    expiredOverlaysText() {
      return `${this.numberOfExpiredOverlays} asset${
        this.numberOfExpiredOverlays > 1 ? 's' : ''
      } expired`;
    },

    isShort() {
      return this.$props.rectangle.width < 100;
    },
  },
};
</script>

<style lang="scss">
.tm-visual-span .tm-visual-expired {
  position: absolute;
  top: 0;
  pointer-events: none;
  z-index: var(--tm-zVisualExpired);

  &.-self {
    background-color: rgba(#fff, 0.8);
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  > .-counter {
    $labelHeight: 24px;

    position: absolute;
    top: #{0 - $labelHeight - 5px};
    left: 0;
    width: auto;
    height: $labelHeight;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    padding: 4px 6px;
    color: $color-negative;
    background-color: $color-orange-d;
  }

  > .-banner {
    font-size: 14px;
    font-weight: 400;
    background-color: $color-orange-d;
    color: #fff;
    padding: 4px 6px;
  }
}
</style>
